import React, { useEffect } from "react";
import "./Blog_Details_Page.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar } from "@fortawesome/free-solid-svg-icons";
import Common_Banner from "../../common/common-banner/Common_Banner";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AllBlogs, BlogDetail } from "../../../features/admin/common/Slice";
import { IDS } from "../../../utils/IDS";

const Blog_Details_Page = () => {
  // const blogData = [
  //   {
  //     id: 1,
  //     image: "/assets/images/home/Our_Blogs/img-1.png",
  //     category: "Data Engineering",
  //     title: "The Role of Data Engineering in Digital Transformation",
  //     date: "January 28, 2026",
  //     desc:
  //       "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout...",
  //   },

  //   {
  //     id: 2,
  //     image: "/assets/images/home/Our_Blogs/img-2.png",
  //     category: "Data Engineering",
  //     title: "The Role of Data Engineering in Digital Transformation",
  //     date: "January 28, 2026",
  //     desc:
  //       "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout...",
  //   },

  //   {
  //     id: 3,
  //     image: "/assets/images/home/Our_Blogs/img-3.png",
  //     category: "Data Engineering",
  //     title: "The Role of Data Engineering in Digital Transformation",
  //     date: "January 28, 2026",
  //     desc:
  //       "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout...",
  //   },
  // ];

  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const blog = useSelector((state) => state?.common?.blog_detail);
  // console.log("blog detail:", blog);

  const blogs = useSelector((state) => state?.common?.all_blogs);

  useEffect(() => {
    dispatch(BlogDetail(id));
    dispatch(AllBlogs());
  }, [id, dispatch]);

  const handleBlogClick = (post) => {
    navigate(`/blog/${post.id}`, { state: post });
  };

  return (
    <section className="Blog_Details_Page  Blogs_Page">
      <Common_Banner title="Blogs" />

      <div className="container">
        <div className="blog_details_section">
          <div className="row justify-content-center">
            <div className="col-lg-7 col-md-7">
              <div className="blog_main">
                <h2 className="blog_main_title">{blog?.heading}</h2>

                <p className="post_date">
                  <span>
                    <FontAwesomeIcon
                      icon={faCalendar}
                      style={{ color: "#BFBFBF" }}
                    />
                  </span>{" "}
                  {blog?.created_at
                    ? new Date(blog.created_at).toDateString()
                    : ""}
                </p>

                <div className="blog_main_image_wrapper">
                  <img
                    src={`${IDS.IMG_URL}${blog?.image}`}
                    alt={blog?.heading}
                    className="blog_main_image"
                  />
                </div>

                <div
                  className="blog_description"
                  dangerouslySetInnerHTML={{ __html: blog?.description }}
                />

                {/* <p className="blog_text">
                    Contrary to popular belief, Lorem Ipsum is not simply random
                    text. It has roots in a piece of classical Latin literature
                    from 45 BC, making it over 2000 years old. Richard
                    McClintock, a Latin professor at Hampden-Sydney College in
                    Virginia, looked up one of the more obscure Latin words,
                    consectetur, from a Lorem Ipsum passage, and going through
                    the cites of the word in classical literature, discovered
                    the undoubtable source. Lorem Ipsum comes from sections
                    1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The
                    Extremes of Good and Evil) by Cicero, written in 45 BC. This
                    book is a treatise on the theory of ethics, very popular
                    during the Renaissance. The first line of Lorem Ipsum,
                    "Lorem ipsum dolor sit amet..", comes from a line in section
                    1.10.32.
                  </p>

                  <h5 className="blog_title">
                    Understanding Big Data Engineering
                  </h5>
                  <p className="blog_text">
                    Contrary to popular belief, Lorem Ipsum is not simply random
                    text. It has roots in a piece of classical Latin literature
                    from 45 BC, making it over 2000 years old. Richard
                    McClintock, a Latin professor at Hampden-Sydney College in
                    Virginia
                  </p>

                  <h5 className="blog_title">
                    What Freshers Typically Learn First
                  </h5>
                  <p className="blog_text">
                    Freshers often wonder what they’ll actually learn before
                    getting started. Honestly, it’s normal to feel a bit unsure.
                    The courses don’t throw everything at you at once. You pick
                    up the fundamentals first and then go step by step. These
                    are some things you usually start with.
                  </p>

                  <ul>
                    <li className="blog_text">
                      Understanding how data is collected from different sources
                    </li>
                    <li className="blog_text">
                      Learning basic programming concepts used to handle data
                    </li>
                    <li className="blog_text">
                      Getting comfortable with databases and simple queries
                    </li>
                    <li className="blog_text">
                      Exploring how large datasets are stored and processed
                    </li>
                  </ul>

                  <p className="blog_text">
                    Contrary to popular belief, Lorem Ipsum is not simply random
                    text. It has roots in a piece of classical Latin literature
                    from 45 BC, making it over 2000 years old. Richard
                    McClintock, a Latin professor at Hampden-Sydney College in
                    Virginia
                  </p> */}
              </div>
            </div>

            <div className="col-lg-3 col-md-5 ">
              <div className="recent_blog_sidebar">
                <h5 className="recent_title">
                  Recent <span>Blogs</span>{" "}
                </h5>
                <div className="recent_blog_list">
                  {blogs
                    ?.filter((post) => post.id !== Number(id))
                    .map((post) => (
                      <div key={post.id}>
                        <div className="blog_card card">
                          <div className="card-body p-0">
                           <div className="blog_img_div">

                          <img
                            src={`${IDS.IMG_URL}${post.image}`}
                            alt={post.heading}
                            className="blog_img"
                          />
                          </div>
                          <div className="category_title">
                            <h5 className="post_title">{post.heading}</h5>
                            <p className="post_date">
                              <span>
                                <FontAwesomeIcon
                                  icon={faCalendar}
                                  style={{ color: "#BFBFBF" }}
                                />
                              </span>{" "}
                              {new Date(post.created_at).toDateString()}
                            </p>
                          </div>
                          <p
                            className="post_desc"
                            dangerouslySetInnerHTML={{
                              __html: post.description.slice(0, 100) + "...",
                            }}
                          />
                          </div>
                          <div className="card-footer p-0">
                          <div className="read_more_div">
                            <button
                              className="read_more_btn"
                              onClick={() => handleBlogClick(post)}
                            >
                              Read More
                            </button>
                          </div>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Blog_Details_Page;
